import React from 'react';
import { useState, useEffect } from 'react';
import { fetchImportantDates } from '../../config';
import './ImportantDates.css';

// Important dates are managed by organisers in the admin portal and served by the
// backend. There is intentionally NO hardcoded fallback list here — while loading we
// show a spinner, and if the backend is unreachable or has no dates configured we show
// a "come back later" notice instead of stale defaults.
const ImportantDates = () => {
  const [celebrateIndex, setCelebrateIndex] = useState(null);
  const [dates, setDates] = useState(null); // null = not loaded / failed; array = loaded
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const fetched = await fetchImportantDates();
      if (cancelled) return;
      setDates(fetched);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const hasDates = Array.isArray(dates) && dates.length > 0;

  return (
    <section className="important-dates">
      <div className="container">
        <div className="dates-grid">
          <h2 className="important-dates-title">Important Dates</h2>

          {loading && (
            <div className="important-dates-status" aria-live="polite">
              Loading important dates…
            </div>
          )}

          {!loading && !hasDates && (
            <div className="important-dates-status" role="note">
              Important dates aren’t available just yet. Please come back later.
            </div>
          )}

          {!loading && hasDates && (
            <div className="timeline">
              {dates.map((item, index) => (
                <div
                  key={index}
                  className={`timeline-item ${item.highlight ? 'highlight' : ''}`}
                >
                  <div className="timeline-dot"></div>
                  <div className="timeline-content">
                    <div className="timeline-date">{item.date}</div>
                    <div
                      className={`timeline-title ${item.highlight ? 'highlight' : ''} ${celebrateIndex === index ? 'celebrate' : ''}`}
                      onMouseEnter={() => item.highlight && setCelebrateIndex(index)}
                      onAnimationEnd={() => setCelebrateIndex(null)}
                    >
                      {item.title}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ImportantDates;
